import { store } from "redux-store/store";
const selectedBrand = () => store.getState().brand.brandType;

export default selectedBrand;
